"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOPIFY_BI_DIRECTIONAL_GATE = void 0;
var SHOPIFY_BI_DIRECTIONAL_GATE = 'Integrations:Shopify:BidirectionalSync';
exports.SHOPIFY_BI_DIRECTIONAL_GATE = SHOPIFY_BI_DIRECTIONAL_GATE;